import {Component, Input} from '@angular/core';
import {NotificationComponentObject} from "../../../classes/notification-component-object";
import {NotificationStore} from "../notification.store";

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  providers: [NotificationStore]
})
export class NotificationComponent {
  @Input() public notification: NotificationComponentObject;
}
